import financialServicesIcon from '../../../public/svg/icons/smartContractIndustriesWePower/financialServices.svg';
import gamingEntertainmentIcon from '../../../public/svg/icons/smartContractIndustriesWePower/gamingEntertainment.svg';
import realEstateIcon from '../../../public/svg/icons/smartContractIndustriesWePower/realEstate.svg';
import supplyChainIcon from '../../../public/svg/icons/smartContractIndustriesWePower/supplyChain.svg';

export const industriesWePowerData = {
  mainText: `Industries We Power`,
  description: `Transforming businesses across sectors with innovative smart contract solutions`,
  services: [
    {
      title: 'Financial Services & DeFi',
      description:
        'Automated escrow systems, programmable payments, regulatory-compliant tokens, and cross-border settlement protocols.',
      list: [
        'Multi-signature treasuries',
        'Automated compliance systems',
        'Programmable payment rails',
        'Regulatory reporting tools',
      ],
      img: financialServicesIcon,
    },
    {
      title: 'Gaming & Entertainment',
      description:
        'Play-to-earn economies, in-game asset ownership, tournament systems, and content creator royalty platforms.',
      list: [
        'NFT-based game assets',
        'Player-owned economies',
        'Tournament prize distribution',
        'Creator royalty systems',
      ],
      img: gamingEntertainmentIcon,
    },
    {
      title: 'Real Estate & Fractional Ownership',
      description:
        'Property tokenization, rental income distribution, and decentralized property management systems.',
      list: [
        'Fractional ownership tokens',
        'Automated rent distribution',
        'Property management DAOs',
        'Investment tracking systems',
      ],
      img: realEstateIcon,
    },
    {
      title: 'Supply Chain & Logistics',
      description:
        'Provenance tracking, automated compliance verification, and multi-party settlement systems.',
      list: [
        'Product authenticity verification',
        'Automated quality assurance',
        'Supplier payment systems',
        'Carbon credit tokenization',
      ],
      img: supplyChainIcon,
    },
  ],
};
